export default "__VITE_ASSET__KIxowpy3__"